import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled, { css } from 'styled-components';
import { sectionMargins } from '../styles';

const StyledFullWidthImage = styled.section`
  ${({ isBlogDetail }) => {
    if (isBlogDetail) {
      return css`
        ${sectionMargins('20px', '40px')};
      `;
    } else {
      return css`
        ${sectionMargins()};
      `;
    }
  }}
`;

const FullWidthImage = ({ image: { gatsbyImageData, alt }, isBlogDetail }) => (
  <StyledFullWidthImage isBlogDetail={isBlogDetail}>
    <GatsbyImage image={gatsbyImageData} alt={alt} />
  </StyledFullWidthImage>
);

export default FullWidthImage;
